<template>
  <BaseNoticeItem :button-text="$t('View existing contract')" :button-url="existingHireUrl">
    <template #head>
      <strong>{{ $t('Contract cannot be accepted') }}</strong>
    </template>
    <template #body>
      <p>
        You cannot accept this contract, as you already have
        <a :href="existingHireUrl">an existing contract</a>
        with different PAYE terms.
      </p>

      <p>To accept this contract, you first need to:</p>

      <ul class="tw-pl-4">
        <li>end the existing contract;</li>
        <li>await payment for outstanding bills;</li>
        <li>
          receive a
          <a href="https://www.gov.uk/paye-forms-p45-p60-p11d">P45 form</a>
          from the client.
        </li>
      </ul>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const existingHireUrl = computed(() =>
  laravelNamedRoute(namedRoutes.messages.show, {
    id: props.complianceData.existingHire.thread_id,
  }),
)
</script>
